import { Moon, Sun } from "lucide-react"
import { useState } from "react"

import { APP_THEME, currentTheme, setTheme, type AppTheme } from "../../lib/theme"
import { cn } from "../../lib/utils"

export function ThemeToggle({ showLabel = false }: { showLabel?: boolean }) {
  const [theme, updateTheme] = useState<AppTheme>(currentTheme)
  const isDark = theme === APP_THEME.dark
  const nextTheme = isDark ? APP_THEME.light : APP_THEME.dark
  const label = isDark ? "Use light mode" : "Use dark mode"

  function handleClick() {
    setTheme(nextTheme)
    updateTheme(nextTheme)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      title={label}
      className={cn(
        "flex h-9 items-center rounded-full border border-border bg-card text-muted-foreground shadow-card outline-none transition-[color,background-color,border-color] hover:bg-muted hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring",
        showLabel ? "w-full gap-3 px-3" : "w-9 justify-center"
      )}
    >
      <span className="relative flex size-4 shrink-0 items-center justify-center overflow-hidden">
        <Sun
          className={cn(
            "absolute size-4 transition-[opacity,transform] duration-200",
            isDark ? "scale-50 rotate-90 opacity-0" : "scale-100 rotate-0 opacity-100"
          )}
        />

        <Moon
          className={cn(
            "absolute size-4 transition-[opacity,transform] duration-200",
            isDark ? "scale-100 rotate-0 opacity-100" : "scale-50 -rotate-90 opacity-0"
          )}
        />
      </span>

      {showLabel ? <span className="truncate text-[13px] font-medium">{label}</span> : null}
    </button>
  )
}
